import React from 'react';
import PropTypes from 'prop-types';
import zxcvbn from 'zxcvbn';

export default class PasswordStrengthIndicator extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            strength: 0
        };
    }

    componentWillReceiveProps(nextProps) {
        const pw = nextProps.password;
        const pwResults = zxcvbn(pw);
        this.setState({
            strength: pwResults.score
        });
    }

    render() {
        switch (this.state.strength) {
            case 4:
                return (
                    <div className="rec-strength-meter-wrapper">
                        <div className="rec-strength-meter">
                            <div className="rec-strength-line bg-green" />
                            <div className="rec-strength-line bg-green" />
                            <div className="rec-strength-line bg-green" />
                            <div className="rec-strength-line bg-green" />
                        </div>
                        <p><strong>Password Strength: Strong</strong> Now that&#39;s a strong password, nice job!</p>
                    </div>);
            case 3:
                return (
                    <div className="rec-strength-meter-wrapper">
                        <div className="rec-strength-meter">
                            <div className="rec-strength-line bg-green" />
                            <div className="rec-strength-line bg-green" />
                            <div className="rec-strength-line bg-green" />
                            <div className="rec-strength-line bg-transparent" />
                        </div>
                        <p><strong>Password Strength: Good</strong> This password will work, but you could still make it stronger. The stronger your password, the harder it will be for someone to guess.</p>
                    </div>
                );
            case 2:
                return (
                    <div className="rec-strength-meter-wrapper">
                        <div className="rec-strength-meter">
                            <div className="rec-strength-line bg-orange" />
                            <div className="rec-strength-line bg-orange" />
                            <div className="rec-strength-line bg-transparent" />
                            <div className="rec-strength-line bg-transparent" />
                        </div>
                        <p><strong>Password Strength: Fair</strong> Try to avoid passwords from other sites or something obvious that would be easy to guess.</p>
                    </div>
                );
            case 1:
                return (
                    <div className="rec-strength-meter-wrapper">
                        <div className="rec-strength-meter">
                            <div className="rec-strength-line bg-red" />
                            <div className="rec-strength-line bg-transparent" />
                            <div className="rec-strength-line bg-transparent" />
                            <div className="rec-strength-line bg-transparent" />
                        </div>
                        <p><strong>Password Strength: Weak</strong> Try to avoid passwords from other sites or something obvious that would be easy to guess.</p>
                    </div>
                );
            default:
                return (
                    <div className="rec-strength-meter-wrapper">
                        <div className="rec-strength-meter">
                            <div className="rec-strength-line bg-transparent" />
                            <div className="rec-strength-line bg-transparent" />
                            <div className="rec-strength-line bg-transparent" />
                            <div className="rec-strength-line bg-transparent" />
                        </div>
                    </div>
                );
        }
    }
}

PasswordStrengthIndicator.propTypes = {
    password: PropTypes.string
};
